module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.error[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "otp"
    }
  }, [_vm._v("Код из СМС")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "otp",
      "placeholder": "Введите код из СМС"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error[0]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fde7d366","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/privat_otp_auth/fields/Otp.vue
// module id = 730
// module chunks = 0